import { getType } from 'typesafe-actions';

import {
    addPanoramaPlaceToCurrentGameRounds,
    setCurrentGame,
    setCurrentMapLayer,
    setTotalRoundCounter,
    setTotalRoundScore,
    incrementStepCount,
    resetStepCount,
} from '../actions/game';

export const mapLayers = {
    default: 'default',
    tourist: 'tourist',
};

// rounds type
/*
roundId: null,
lat:
lon:
bestPanoramaPlace: null,
 */

const initialState = {
    currentGame: {
        mode: null,
        round: null,
        totalScore: 0,
        radius: 1,
        city: null,
        regionNutCode: null,
        guessResultMode: null,
        noMove: false,
        currentMapLayer: mapLayers.default,
        rounds: [],
        stepCount: 0, // Počet načtení panoramatu v kole (per-tile účtováno; nepočítá preloady/retry)
    },
};

const gameReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(setCurrentGame): {
            // Pokud se nastavuje nová hra (round: 1), resetujeme stepCount
            const shouldResetSteps = action.payload?.round === 1;
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    ...action.payload,
                    stepCount: shouldResetSteps ? 0 : (action.payload?.stepCount ?? state.currentGame.stepCount),
                },
            };
        }
        case getType(setTotalRoundScore):
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    totalScore: action.payload,
                },
            };
        case getType(addPanoramaPlaceToCurrentGameRounds): {
            const currentGameRounds = state.currentGame.rounds;
            currentGameRounds.push(action.payload);
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    rounds: currentGameRounds,
                },
            };
        }
        case getType(setTotalRoundCounter):
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    round: action.payload,
                },
            };
        case getType(setCurrentMapLayer):
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    currentMapLayer: action.payload,
                },
            };
        case getType(incrementStepCount):
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    stepCount: state.currentGame.stepCount + 1,
                },
            };
        case getType(resetStepCount):
            return {
                ...state,
                currentGame: {
                    ...state.currentGame,
                    stepCount: 0,
                },
            };
        default:
            return state;
    }
};

export default gameReducer;
